export class SalutationComponent {
    private readonly radioFieldMisses: HTMLInputElement;
    private readonly radioFieldMister: HTMLInputElement;
    private readonly radioFieldUnknown?: HTMLInputElement;
    private readonly errorHint: HTMLElement;
    private readonly validateImmediately: boolean;
    private readonly hasSalutation: boolean;

    constructor(document: Document, validateImmediately: boolean, hasSalutation: boolean) {
        this.radioFieldMisses = document.querySelector<HTMLInputElement>(`[id="fti-registration-salutation-MISSES"]`)!;
        this.radioFieldMister = document.querySelector<HTMLInputElement>(`[id="fti-registration-salutation-MISTER"]`)!;
        this.radioFieldUnknown = document.querySelector<HTMLInputElement>(`[id="fti-registration-salutation-UNKNOWN"]`)!;
        this.errorHint = document.querySelector<HTMLElement>(`[id="fti-registration-salutation-error"]`)!;
        this.validateImmediately = validateImmediately;
        this.hasSalutation = hasSalutation;
        if (!this.hasSalutation) {
            this.radioFieldMisses.checked = false;
            this.radioFieldMister.checked = false;
            if (this.radioFieldUnknown) {
                this.radioFieldUnknown.checked = false;
            }
        }
        this.registerEventListeners();
    }

    /*                      */
    private registerEventListeners() {
        const inputListener = () => this.updateStatus();

        const focusListener = () => {
            this.registerEventListener("input", inputListener);
            return this.updateStatus();
        };
        this.registerEventListener(this.validateImmediately ? "focusin" : "focusout", focusListener);
    }

    private registerEventListener(eventType: string, listener: () => void) {
        this.radioFieldMisses.removeEventListener(eventType, listener);
        this.radioFieldMister.removeEventListener(eventType, listener);
        this.radioFieldMisses.addEventListener(eventType, listener);
        this.radioFieldMister.addEventListener(eventType, listener);
        if (this.radioFieldUnknown) {
            this.radioFieldUnknown.removeEventListener(eventType, listener);
            this.radioFieldUnknown.addEventListener(eventType, listener);
        }
    }

    /*                      */
    updateStatus() {
        if (this.radioFieldMisses.checked.valueOf()
            || this.radioFieldMister.checked.valueOf()
            || this.radioFieldUnknown?.checked.valueOf()) {
            this.hideErrors(this.errorHint);
        } else {
            this.showErrors(this.errorHint);
        }
    }

    /*                      */
    private hideErrors(field: HTMLElement) {
        field.parentElement!.classList.remove("pl_radio--invalid");
        this.errorHint.style.display = "none";
    }

    /*                      */
    private showErrors(field: HTMLElement) {
        field.parentElement!.classList.add("pl_radio--invalid");
        this.errorHint.style.display = "unset";
    }
}
